import React, { useState, useEffect } from "react";
import { AiFillEye, AiFillGithub } from "react-icons/ai";
import { motion } from "framer-motion";
import { AppWrap, MotionWrap } from "../../wrapper";
import { urlFor, client } from "../../client";
import { useNavigate } from "react-router-dom";
import "./Work.scss";
import useSanity from "../../customHooks/useSanity";


const Work = () => {
	const { works, categories } = useSanity();
	const navigate = useNavigate();
	const [activeFilter, setActiveFilter] = useState("All");
	const [animateCard, setAnimateCard] = useState({
		y: 0,
		opacity: 1,
	});
	const [filterWork, setFilterWork] = useState([]);

	const handleShowcase = (project, showcase) => {
		const showcaseUrl = `/showcase/${project._id}`;
		if (showcase) {
			navigate(showcaseUrl, { state: { showcase } }); 
		}
	
	};

	useEffect(() => {
		setFilterWork(works);
	}, [works]);

	const handleWorkFilter = (item) => {
		setActiveFilter(item);
		setAnimateCard([{ y: 100, opacity: 0 }]);

		setTimeout(() => {
			setAnimateCard([{ y: 0, opacity: 1 }]);

			if (item === "All") {
				setFilterWork(works);
			} else {
				setFilterWork(
					works.filter((work) =>
						work.category.some(
							(cat) => cat.title === item
						)
					)
				);
			}
		}, 500);
	};

	return (
		<>
			<h2 className="head-text">
				My Creative <span>Portfolio</span> Section
			</h2>
			<div className="app__work-filter">
				{[...categories]
					.sort((a, b) => a.title.localeCompare(b.title))
					.map((category, index) => (
						<div
							key={index}
							onClick={() =>
								handleWorkFilter(category.title)
							}
							className={`app__work-filter-item app__flex p-text ${
								activeFilter === category.title
									? "item-active"
									: ""
							}`}
						>
							{category.title}
						</div>
					))}
				<div
					key="all"
					onClick={() => handleWorkFilter("All")}
					className={`app__work-filter-item app__flex p-text ${
						activeFilter === "All" ? "item-active" : ""
					}`}
				>
					All
				</div>
			</div>
			<motion.div
				animate={animateCard}
				transition={{ duration: 0.5, delayChildren: 0.5 }}
				className="app__work-portfolio"
			>
				{filterWork.map((work, index) => (
					<div
						onClick={() =>
							handleShowcase(work, work.showcase)
						}
						className="app__work-item app__flex"
						key={index}
					>
						<div className="app__work-img app__flex">
							<img
								src={urlFor(work.imgUrl)}
								alt={work.title}
							/>
							<motion.div
								whileHover={{ opacity: [0, 1] }}
								transition={{
									duration: 0.25,
									ease: "easeInOut",
									staggerChildren: 0.5,
								}}
								className="app__work-hover app__flex"
							>
								<span
									onClick={() =>
										handleShowcase(
											work,
											work.showcase
										)
									}
								>
									<motion.div
										whileInView={{
											scale: [0, 1],
										}}
										whileHover={{
											scale: [1, 0.9],
										}}
										transition={{
											duration: 0.25,
										}}
										className="app__flex"
									>
										<AiFillEye />
									</motion.div>
								</span>
								<a
									href={work.codeLink}
									target="_blank"
									rel="noreferrer"
								>
									<motion.div
										whileInView={{
											scale: [0, 1],
										}}
										whileHover={{
											scale: [1, 0.9],
										}}
										transition={{
											duration: 0.25,
										}}
										className="app__flex"
									>
										<AiFillGithub />
									</motion.div>
								</a>
							</motion.div>
						</div>

						<div className="app__work-content app__flex">
							<h4 className="bold-text">
								{work.title}
							</h4>
							<p
								className="p-text"
								style={{ marginTop: 10 }}
							>
								{work.description}
							</p>
							<div className="app__work-tag app__flex">
								{work.category
									.slice(0, 2)
									.map(
										(category, categoryIndex) => (
											<React.Fragment
												key={categoryIndex}
											>
												<p className="p-text">
													{category.title}
												</p>
												{categoryIndex ===
													0 &&
													work.category
														.length >
														1 && (
														<p className="p-text">
															|
														</p>
													)}
											</React.Fragment>
										)
									)}
							</div>
						</div>
					</div>
				))}
			</motion.div>
		</>
	);
};

export default AppWrap(
	MotionWrap(Work, "app__works"),
	"portfolio",
	"app__primarybg"
);
